// Modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getLang } from 'redux-pagan';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';
// Components
import QuantitativeFilters from '../../components/QuantitativeFilters/QuantitativeFilters';
import AdditionalFilters from '../../components/AdditionalFilters/AdditionalFilters';
import ButtonsFormsControls from '../../components/ButtonsFormsControls/ButtonsFormsControls';
import Drawer from '../../components/Drawer/Drawer';
// Redux
import { hideAdvancedFilters } from '../../redux/modules/advancedFilters';
// Helpers
import { advancedFiltersInitialValues, constructionYearMax, constructionYearMin, sections } from '../../constants';
import { extractRouteData } from '../../helpers/routerAdapter';
import { clearSearchPageLocation } from '../../helpers/clearSearchPageLocation';
// Styles
import * as styles from './AdvancedFilters.scss';


const fields = Object.keys(advancedFiltersInitialValues);

class AdvancedFilters extends Component {
  constructor(props) {
    super(props);
    const { params: { notLastFloor = null, parkingSpot = null, elevator = null, balcony = null, photos = null,
      vr = null, commodities = [], toilets, bathrooms, floor, area, constructionYear,
      price: { minPrice, maxPrice } }, location: routeLocation } = props.routeData;
    const location = clearSearchPageLocation(routeLocation);
    this.state = (props.isMobile && location !== '')
      ? {
        floor: (floor) ? { min: floor.min, max: floor.max } : { ...advancedFiltersInitialValues.floor },
        notLastFloor,
        parkingSpot,
        elevator,
        balcony,
        photos,
        vr,
        commodities,
        price: {
          minPrice: minPrice || '',
          maxPrice: maxPrice || ''
        },
        area: area || {},
        constructionYear: constructionYear || {},
        toilets: toilets || ['all'],
        bathrooms: bathrooms || ['all']
      }
      : {
        ...advancedFiltersInitialValues,
        price: {
          minPrice: minPrice || '',
          maxPrice: maxPrice || ''
        },
        area: area || {},
        constructionYear: constructionYear || {},
        toilets: toilets || ['all'],
        bathrooms: bathrooms || ['all']
      };
  }


  componentDidMount() {
    if (!this.props.resetButtonId) {
      return;
    }

    // Why not simple onclick?
    this.resetButton = document.querySelector(`#${this.props.resetButtonId}`);
    if (this.resetButton) {
      this.resetButton.addEventListener('click', this.clearFilters);
    }

    if (this.props.resetAdvancedFilters) {
      this.clearFilters();
    }
  }

  componentWillReceiveProps(newProps) {
    const { isAdvancedFiltersOpen, routeData: { params } } = newProps;
    const parameters = params.commodities ? { ...params, commodities: [...params.commodities] } : { ...params };
    if (isAdvancedFiltersOpen && !this.props.isAdvancedFiltersOpen) {
      const fieldsData = {};
      fields.forEach((field) => {
        if (parameters[field]) {
          fieldsData[field] = parameters[field];
        }
      });
      if (!isEqual(this.state, fieldsData) && !isEmpty(fieldsData)) {
        this.setState({ ...advancedFiltersInitialValues, ...fieldsData });
      }
    }
  }

  shouldComponentUpdate({ isAdvancedFiltersOpen, isMobile }, nextState) {
    if (isMobile && !isEqual(nextState, this.state)) {
      this.props.getAdvancedFiltersValues(nextState);
    }
    if (!isMobile && !isAdvancedFiltersOpen && !this.props.isAdvancedFiltersOpen) {
      return false;
    }
    const { floor: { min, max } } = nextState;
    return !(max > 0 && min !== this.state.floor.min && min > max);
  }

  componentWillUnmount() {
    if (this.resetButton) {
      this.resetButton.removeEventListener('click', this.clearFilters);
    }
  }

  handleClose = () => {
    this.clearFilters();
    this.props.hideAdvancedFilters();
  };

  handleChange = (field, value) => {
    this.setState({ [field]: value });
    if (this.props.isMobile) {
      this.props.handleChange('advancedFilters', { ...this.state, [field]: value });
    }
  };

  handleChangeCommodities = (value) => {
    const values = [...this.state.commodities];
    const index = this.state.commodities.indexOf(value);
    if (index >= 0) {
      values.splice(index, 1);
    } else {
      values.push(value);
    }
    this.setState({ commodities: values });
    if (this.props.isMobile) {
      this.props.handleChange('advancedFilters', { ...this.state, commodities: values });
    }
  };

  handleCheckMaxValue = (field) => {
    const { [field]: { min, max } } = this.state;
    const minValue = +min;
    const maxValue = +max;

    if (minValue >= 0 && max < minValue) {
      this.setState({ [field]: { min, max: 0 } });
    }
    if (field === 'constructionYear') {
      if (minValue >= 0 && (minValue < constructionYearMin || minValue > constructionYearMax)) {
        this.setState({ [field]: { min: 0, max: maxValue } });
      }
      if (maxValue >= 0 && (maxValue < constructionYearMin || maxValue > constructionYearMax)) {
        this.setState({ [field]: { min: minValue, max: 0 } });
      }
      if (minValue >= 0 && (minValue < constructionYearMin || minValue > constructionYearMax) &&
        (maxValue > 0 && (maxValue < constructionYearMin || maxValue > constructionYearMax))) {
        this.setState({ [field]: { min: 0, max: 0 } });
      }
    }
  };

  clearFilters = () => this.setState({
    ...advancedFiltersInitialValues,
    commodities: [],
    toilets: ['all'],
    bathrooms: ['all'],
    constructionYear: {},
    area: {}
  });

  renderFilters(className) {
    const { translate, locale, isMobile, routeData: { optionType } } = this.props;
    const photosFieldData = {
      value: this.state.photos,
      checked: this.state.photos,
      onChange: () => this.handleChange('photos', !this.state.photos)
    };
    const vrFieldData = {
      value: this.state.vr,
      checked: this.state.vr,
      onChange: () => this.handleChange('vr', !this.state.vr)
    };
    return (
      <div className={className}>
        <QuantitativeFilters
          onChange={this.handleChange}
          handleCheckMaxValue={this.handleCheckMaxValue}
          fields={this.state}
          translate={translate}
          isMobile={isMobile}
        />
        <AdditionalFilters
          translate={translate}
          locale={locale}
          onChange={this.handleChangeCommodities}
          photosField={photosFieldData}
          vrField={vrFieldData}
          commodities={this.state.commodities}
          onBathToiletsChange={this.handleChange}
          bathrooms={this.state.bathrooms}
          toilets={this.state.toilets}
          location={
            clearSearchPageLocation(get(this.props, 'routeData.location')) || sections.homes.location
          }
          optionType={isMobile ? this.props.optionType : optionType}
        />
      </div>
    );
  }

  render() {
    const { isAdvancedFiltersOpen, translate, isMobile, routeData } = this.props;
    if (isMobile) {
      return (
        <div>{this.renderFilters(styles.filters)}</div>
      );
    }

    return (
      <Drawer isOpen={isAdvancedFiltersOpen} onClose={this.handleClose} title={translate('advancedFilters', 'title')()}>
        {this.renderFilters(styles.additionalFilters)}
        <ButtonsFormsControls
          className="modalFooter"
          fields={this.state}
          locale={this.props.locale}
          resetForm={this.clearFilters}
          translate={translate}
          routeData={routeData}
          hideAdvancedFilters={this.props.hideAdvancedFilters}
        />
      </Drawer>
    );
  }
}

AdvancedFilters.propTypes = {
  isAdvancedFiltersOpen: PropTypes.bool,
  hideAdvancedFilters: PropTypes.func,
  translate: PropTypes.func,
  locale: PropTypes.string,
  routeData: PropTypes.object,
  isMobile: PropTypes.bool,
  scrollTop: PropTypes.func,
  getAdvancedFiltersValues: PropTypes.func,
  isRtl: PropTypes.bool,
  resetAdvancedFilters: PropTypes.bool,
  resetButton: PropTypes.object,
  resetButtonId: PropTypes.string,
  handleChange: PropTypes.func,
  optionType: PropTypes.string
};

const mapStateToProps = ({
  routing,
  advancedFilters: { isAdvancedFiltersOpen },
  lang,
  windowDimentions: { isMobile }
}) => {
  const routeData = extractRouteData(routing, lang.locale);
  return {
    routeData,
    translate: getLang(lang, 'static'),
    isAdvancedFiltersOpen,
    locale: routeData.locale,
    isMobile
  };
};

export default connect(mapStateToProps, { hideAdvancedFilters })(
  AdvancedFilters
);
